import { Component } from 'react';
import PropTypes from 'prop-types';
import {isValidImage} from "../../utils/CleversiteUtilities";

export default class ImageComponent extends Component {
    static propTypes = {
        src: PropTypes.string.isRequired,
        alt: PropTypes.string.isRequired,
        isBackground: PropTypes.bool,
        className: PropTypes.string,
        onClick: PropTypes.func,
        onLoad: PropTypes.func,
        fallbackSrc: PropTypes.string,
    };

    static defaultProps = {
        src: "",
        alt: "",
        isBackground: false,
        className: "",
        onClick: () => {
        },
        onLoad: () => {
        },
        fallbackSrc: "",
    };

    constructor(props) {
        super(props);

        this.state = {
            src: props.src,
        }
    }

    componentDidMount() {
       if (this.props.fallbackSrc) {
           isValidImage(this.state.src)
               .then(isValid => {
                   if (!isValid) {
                       this.setState({
                           src: this.props.fallbackSrc,
                       })
                   }
               })
       }

    }

    render() {
        const {alt, isBackground, className, fallbackSrc, ...restProps} = this.props;

        let image;
        if (isBackground) {
            image =
                <div onClick={this.props.onClick} {...restProps} style={{backgroundImage: `url(${JSON.stringify(this.state.src)})`}}
                     className={className}
                     role="img" title={alt}>{this.props.children}</div>
        } else {
            image = <img onLoad={this.props.onLoad} onClick={this.props.onClick} {...restProps} src={this.state.src}
                           className={className} aria-label={alt} alt={alt} />
        }

        return image;
    }
}
